module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-02.1@2x.15972ae0.jpg";